module.exports = __webpack_public_path__ + "img/baby7.4405f3a5.jpg";